import { DeleteInvitedTeamMeta, DeleteInvitedTeamPayload } from 'types/store/DeleteInvitedTeam';
import { createAsyncReducer } from 'utils/Redux';

import { deleteInvitedTeamActions } from '../actions';

export default createAsyncReducer<DeleteInvitedTeamMeta, DeleteInvitedTeamPayload>(deleteInvitedTeamActions);
